<style>
@import '../custom/css/cadastro.css';
</style>

<template>
  <div class="cadastro">
    <div class="container">
      <!-- Breadcrumb -->
      <div class="row p-25">
        <div class="col-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link
                  class="text-uppercase"
                  class-active="active"
                  :to="{ name: 'home' }"
                  >Ínicio</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link
                  class="text-uppercase"
                  class-active="active"
                  :to="{ name: 'area-restrita' }"
                  >Área Restrita</router-link
                >
              </li>
              <li
                aria-current="page"
                class="breadcrumb-item active text-uppercase"
              >
                Cadastro
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 text-center"
          v-if="this.tipoUsuario !== this.UserTypes.PARTNER && !specialRegister"
        >
          <h1 class="h1-after-center text-uppercase fwb mb-4" id="inicio">
            Dados Cadastrais
          </h1>
          <div class="box-desc text-center">
            <p class="roboto-n max-w-500 m-0-auto p-b-3em">
              Preencha seus dados cadastrais abaixo.
            </p>
          </div>
        </div>
        <div class="col-12">
          <div>
            <!-- Checkbutton para selecionar o tipo de usuario -->
            <div v-if="!specialRegister && totalRouteParams === 0"> 
              <div class="">
                <div class="form-group">
                  <b-form-radio-group
                    v-if="this.tipoUsuario !== this.UserTypes.PARTNER"
                    id="cadastroTipoUsuario"
                    class="row justify-content-around"
                  >
                    <b-form-radio
                      v-for="(tipo, index) in usersTypesValidForRegistration"
                      v-show="tipo.id != 10 && tipo.id != 11"
                      :class="[tipo.nome === 'Profissional' ? 'mr-1' : '']"
                      v-model="tipoUsuario"
                      :value="tipo.id"
                      :key="index"
                      :id="tipo.id.toString()"
                    >
                      <a class="pointer">
                        <i
                          :class="
                            'fas fs-18 ' +
                            [
                              tipo.id === UserTypes.CLIENT
                                ? 'fa-user'
                                : tipo.id === UserTypes.PROFESSIONAL
                                ? 'fa-hard-hat'
                                : tipo.id === UserTypes.SHOPKEEPER
                                ? 'fa-store'
                                : '',
                            ]
                          "
                        ></i>
                      </a>
                      <span v-if="tipo.id != 7"
                        >{{ tipo.nome }}
                        <i
                          class="fas fa-question-circle question-tool-tips"
                          :id="tipo.nome"
                        ></i
                      ></span>
                    </b-form-radio>
                  </b-form-radio-group>

                  <BTooltip
                    :ref="tipo.nome"
                    :target="tipo.nome"
                    v-for="(tipo, index) in usersTypesValidForRegistration"
                    :key="index"
                  >
                    <div v-if="tipo.nome === 'Cliente'">
                      Cadastro destinado a quem deseja cotar materiais de
                      contrução e encontrar profissionais do setor
                    </div>
                    <div v-if="tipo.id === UserTypes.PROFESSIONAL">
                      Cadastro destinado a quem deseja oferecer seus serviços
                    </div>
                    <div v-if="tipo.id === UserTypes.SHOPKEEPER">
                      Cadastro destinado a quem deseja vender materiais de
                      construção
                    </div>
                    <div v-if="tipo.id === UserTypes.REPRESENTATIVE">
                      Cadastro destinado a quem deseja vender materiais para os
                      lojistas
                    </div>
                    <!-- <div v-if="tipo.id === UserTypes.AFFILIATE">
                      Cadastro destinado a quem deseja fazer uma parceiria
                      com a Constr Up
                    </div> -->
                  </BTooltip>
                </div>
              </div>
            </div>
            <!-- Formulário para cliente -->
            <ClientRegister
              v-if="tipoUsuario === UserTypes.CLIENT"
              :cities="cidades"
              :states="estados"
            />

            <!-- Formulário para Afiliado -->
            <AffiliateRegister
              v-if="tipoUsuario === UserTypes.AFFILIATE"
              :segments="segmentos"
            />

            <!-- Formulário para Parceiro -->
            <PartnerRegister
              v-if="tipoUsuario === UserTypes.PARTNER"
              :segments="segmentos"
              :externo="this.externo"
            />

            <!-- Formulario para profissionais -->
            <ProfessionalRegister
              v-if="tipoUsuario === UserTypes.PROFESSIONAL"
              :cities="cidades"
              :states="estados"
            />

            <!-- Formulario para lojista -->
            <ShopkeeperRegister
              v-if="tipoUsuario === UserTypes.SHOPKEEPER"
              :cities="cidades"
              :states="estados"
            />

            <PartnerRegisterShopkeeper
              v-else-if="partnerId"
              :cities="cidades"
              :states="estados"
              :partnerId="partnerId"
            />

            <!-- Formulario para Representante -->
            <RepresentativeRegister
              v-if="tipoUsuario === UserTypes.REPRESENTATIVE"
              :cities="cidades"
              :states="estados"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Termos e Condições -->
    <TermsAndConditions />
    <!-- Política de Privacidade -->
    <PrivacyPolicy />

    <!-- Contrato Lojista Plano 1 -->
    <ShopkeeperContractPlan1 v-if="tipoUsuario === UserTypes.SHOPKEEPER" />
    <!-- Contrato Lojista Plano 2 -->
    <ShopkeeperContractPlan2 v-if="tipoUsuario === UserTypes.SHOPKEEPER" />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters, mapActions } from 'vuex';
import TermsAndConditions from '../components/TermsAndConditions.vue';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import ShopkeeperContractPlan1 from '../components/ShopkeeperContractPlan1.vue';
import ShopkeeperContractPlan2 from '../components/ShopkeeperContractPlan2.vue';
import ShopkeeperSpecialRegister from './ShopkeeperSpecialRegister.vue';
import ClientRegister from './cliente/Register.vue';
import AffiliateRegister from './affiliate/Register.vue';
import PartnerRegister from './partner/Register.vue';
import PartnerRegisterShopkeeper from './partner/RegisterShopkeeper.vue';
import ShopkeeperRegister from './lojista/Register.vue';
import ProfessionalRegister from './profissional/Register.vue';
import RepresentativeRegister from './representante/Register.vue';
import makeToast from '../mixins/makeToast';
import UserTypes from "../enums/UserTypes";
import scrollToElement from '../mixins/scrollToElement';

export default {
  name: "cadastro",
  mixins: [makeToast, scrollToElement],
  components: {
    TermsAndConditions,
    PrivacyPolicy,
    ShopkeeperContractPlan1,
    ShopkeeperContractPlan2,
    ClientRegister,
    AffiliateRegister,
    ShopkeeperRegister,
    ShopkeeperSpecialRegister,
    RepresentativeRegister,
    ProfessionalRegister,
    PartnerRegister,
    PartnerRegisterShopkeeper,
  },
  data() {
    return {
      UserTypes,
      tipoUsuario: 0,
      afiliadoId: 0,
      partnerId: '',
      typePerson: '',
      Fields: {
        paymentPlan: '',
        cep: '',
        endereco: '',
        bairro: '',
        cidade_id: null,
      },
      ErrorMessages: {
        paymentPlan: null,
        address: null,
        cep: null,
        neighborhood: null,
        city: null,
      },
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
      specialRegister: false,
      externo: false,
    };
  },
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification', 'getBaseUri']),
    ...mapGetters('general', ['getCities']),
    ...mapState([
      'tipoUsuarios',
      'estados',
      'cidades',
      'planos',
      'segmentos',
      'dadosUsuario',
    ]),
    usersTypesValidForRegistration() {
      return this.tipoUsuarios.filter(
        (userType) =>
          userType.id !== this.UserTypes.ADMINISTRATOR &&
          userType.id !== this.UserTypes.EDITOR &&
          // && userType.id !== this.UserTypes.AFFILIATED
          userType.id !== this.UserTypes.REPRESENTATIVE &&
          userType.id !== this.UserTypes.GUEST &&
          userType.id !== this.UserTypes.PARTNER
      );
    },
    totalRouteParams() {
      return Object.keys(this.$route.query || {}).length
    }
  },
  beforeCreate() {
    this.$store.dispatch('loadTipoUsuarios');
    this.$store.dispatch('loadEstados');
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadPlanos');
    this.$store.dispatch('loadSegmentos');
  },
  created() {
    this.scrollToElement();
    if (this.$route.params.type) {
      if (
        this.$route.params.type === 'parceiro' ||
        this.$route.params.type === 'parceiro-ext'
      ) {
        this.tipoUsuario = this.UserTypes.PARTNER;

        if (this.$route.params.type === 'parceiro-ext') this.externo = true;

        return;
      }

      this.tipoUsuario = parseInt(this.$route.params.type, 10);
    }

    if (this.$route.query.referencia) {
      this.tipoUsuario = UserTypes.SHOPKEEPER;
      this.specialRegister = true;
    }

    const partnerId = this.$route.query.parceiro;

    if (partnerId) {
      this.validateInviteId(partnerId)
        .then(() => {
          this.partnerId = partnerId;
        })
        .catch(() => {
          this.$router.push({ name: 'codigo-invalido' });
        });
    }
  },
  beforeMount() {
    if (this.$router.history.current.name === "cadastro") {

      if (this.checkIsEmpty(this.token)) {
        this.$router.push({ name: 'area-restrita' });
      } else {
        this.$router.push({ name: 'cadastro', query: this.$route.params });
      }
    }
  },
  mounted() {
    this.getAllCities();
    this.scrollToElement();
  },
  methods: {
    ...mapActions('general', ['getAllCities']),
    ...mapActions('partner', ['validateInviteId']),
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === 'null' ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
